import React, { useContext, useState, useEffect,useRef } from 'react';
import { Row, Col, Form, Tabs, Modal } from 'antd';
import {
  Button,
  Checkbox,
  Input,
  SelectFile
} from 'components';

import { useHistory, useParams } from 'react-router-dom';
import MessagesSummary from './partials/messages-summary';

import ArrowRight from 'assests/icons/arrow-right';
import UploadIcon from 'assests/icons/upload.icon';
import '../../../Messages/message-steps/steps.less';
import '../create-title-step-1.less';
import ArrowLeft from 'assests/icons/arrow-left';
import { DimensionsContext } from 'context/dimensions.context';

import  *  as alphaService from 'services/alpha.service';

import  {fetchLastAgreement} from 'services/agreement.service';

import { customMessages } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import {turkishToUpper} from 'utils/utility-functions';

import { useDebounce,useDebouncedCallback  } from 'use-debounce';


const CompanyTitle = (props) => {
  const history = useHistory();

    const {current,firmData,newFirm} = props;
    const {user} = useSelector(state=>state.auth);
    const [validAlpha, setValidAlpha] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    const [selectTitleModal, setSelectTitleModal] = useState(false);
    
    const [selectAgreementModal, setSelectAgreementModal] = useState(false);
    const [agreementContent, setAgreementContent] = useState("");
    const [form] = Form.useForm();

    const [valid, setValid] = useState(false);
    const [formValues,setFormValues]=useState({});


    const [agreementClicked,setAgreementClicked]=useState(false);
    const [kepApproval, setKepApproval] = useState(false);
    const [additionalFileList, setAdditionalFileList]=useState([]);
    const [taxFileList, setTaxFileList]=useState([]);
    const [commercialFileList, setCommercialFileList]=useState([]);

    const [modalInfo, setModalInfo] = useState(true);

  // const onValuesChange = () => {
  //   setTimeout(() => {
  //     let inputs = form.getFieldsError();

  //     for (var i = 0; i < inputs.length; i++) {
  //       let formItemName = inputs[i]['name'][0];
  //       if (checkError(formItemName)) {
  //         setValid(true);
  //       } else {
  //         setValid(false);
  //         break;
  //       }
  //     }
  //   }, 10);
  // };

  const onCreateNewTitle = (values) =>
  {
    
    values.additionalFile=additionalFileList;
    values.commercialFile=commercialFileList;
    values.taxFileList=taxFileList;
    values.brandCode="";
    values={...firmData.user, ...values};
    if (newFirm)
    {
      alphaService.createNewFirm(values).then((result) => {
        history.push(`/Title`);
        })
        .catch((response) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(response.responseCode),
          });
        });
    }
    else
    {
      alphaService.createNewAlphaNumeric(values).then((result) => {
        history.push(`/Title`);
        })
        .catch((response) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(response.responseCode),
          });
        });
    }
  
  }



  const validateAlpha = useDebouncedCallback(
    // function
    (rule, value, callback) => {
      if (value && value.length>3)
        {
          alphaService.validateAlpha({alpha:value }).then((result) => {
            setValidAlpha(true);
            callback();
            setErrorMessage("");
          })
          .catch((response) => {
            console.log("a");
            setValidAlpha(false);
            callback(customMessages.getMessage(response.responseCode));
              setErrorMessage(customMessages.getMessage(response.responseCode));
          });
        }
    },
    // delay in ms
    500
  );




  const checkError = (fieldName) => {
    if (
      form.isFieldTouched(fieldName) &&
      form.getFieldError(fieldName).length === 0
    ) {
      return true;
    }
  };

  const openPopupAgreement = () =>
  {
    
    fetchLastAgreement().then((response) => {
      setAgreementContent(response);
      setSelectAgreementModal(true);
    }).catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }

  
  const openTitlePopup = () =>
  {
    if (newFirm)
    {
      if (taxFileList.length==0 || !commercialFileList.length==0) 
      {
        Modal.error({
          title: 'Hata',
          content: "Lütfen Ticari faliyet belgesi ve Vergi levhası yükleyiniz!",
        });
        return;
      }
    }
    setSelectTitleModal(true);
  }

  useEffect(() => {
    if (firmData.userFirm) {
        form.setFieldsValue({
            kurumAdi: firmData.userFirm.kurumAdi,
            vergiDairesi:firmData.userFirm.vergiDairesi,
            vergiNo:firmData.userFirm.vergiNo
          });
        setValid(true);
      }
      form.setFieldsValue({
        mail: user.loginEmail
      });
    }, [firmData.userFirm,current]);


    function onPrev ()
    {
      props.updateCurrent(0);
    }

    const onCloseModal = () =>
    {
      setSelectAgreementModal(false);
    }

  return (
  <>
<React.Fragment> 
                <Modal
                    title="Sözleşme"
                   width={800}
                                        visible={selectAgreementModal}
                    onCancel={() => onCloseModal()}
                    footer={[
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() =>onCloseModal()}
                        >
                          Kapat
                        </Button>
                      </div>
                    ]}
                  >
                      <div  className="agreement-content" dangerouslySetInnerHTML={ {__html:agreementContent}} />
                  </Modal>
  
  
  <Modal
                    title="Ünvan Seçin"
                    visible={selectTitleModal}
                    onCancel={() => setSelectTitleModal(false)}
                    footer={[
                      <div className="modal-action">
                        <Button
                          shape="round"
                          type="ghost"
                          onClick={() => setSelectTitleModal(false)}
                        >
                          Vazgeç
                        </Button>
                        <Button 
                          key="confirm" form="newTitle" htmlType="submit"
                          type="primary" disabled={(!validAlpha || !kepApproval || !agreementClicked)}                    
                        >
                          Onaya Gönder
                        </Button>
                      </div>,
                    ]}
                  >
                    <div>
                      <Form form={form} id="newTitle" 
                      name="choose-title" 
                      onFinish={(values)=>onCreateNewTitle(values)}
                      
                      
                      >
                        <Form.Item hasFeedback   
                          rules={[{ required: true, validator:validateAlpha }]} 
                          name="title" 
                          messageVariables={{ label: 'title' }} 
                        >
                          <Input
                            type="text"
                            name="Title" 
                            label="Ünvanınız" 
                            info={
                              <span>
                                Telefonda mesaj başlığı olarak görünecek
                                gönderen ismi. 
                              </span>
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          name="email" initialValue={user.loginEmail}
                          messageVariables={{ label: 'e-mail' }}
                        >
                          <Input disabled={!newFirm}
                            type="email"
                            name="email"
                            label="Mail Adresiniz"
                          />
                        </Form.Item>
                        <Form.Item name="chekbox" messageVariables="checkbox">
                          <Checkbox onChange={(e)=>{setAgreementClicked(e.target.checked)}}
                            text={
                              <>
                                <a onClick={()=>openPopupAgreement()}>Sözleşme</a>yi okudum,
                                kabul ediyorum ve yukarıdaki e-mail adresime
                                gönderilmesini talep ediyorum.
                              </>
                            }
                          />
                        </Form.Item>
                        <Form.Item name="chekbox2" messageVariables="checkbox">
                          <Checkbox onChange={(e)=>{setKepApproval(e.target.checked)}}
                            text={
                              <>
                                Yüklediğim belgeleri <strong
                                 style={{ letterSpacing: '-1.5px'}}>48</strong>{' '}
                                 <strong>saat</strong> içinde KEP hesabım üzerinden <strong>turkcell.mesajussu@hs03.kep.tr</strong> adresine göndereceğimi,
                                 aksi halde başvurumun iptal edileceğini kabul ediyorum.
                              </>
                            }
                          />
                        </Form.Item>
                      </Form>
                    </div>
                  </Modal>
    
        <Form
          form={form}
          name="create-title-step-2"
          onFinish={(values)=>onCreateNewTitle(values)}
        >
          <div className="step-transitions">
            <div className="container">
              <div className="step-transitions_left"></div>
             
                <div className="step-transitions__right">
                  <Button
                    type="ghost"
                    className="circle"
                    onClick={onPrev}
                  >
                    <ArrowLeft />
                  </Button>
                  <Button
                    type="primary"
                    shape="round"
                    className="ant-btn--icon"
                    onClick={() => {
                      openTitlePopup();
                    }}
                  >
                    Ünvanınızı Seçiniz
                    <ArrowRight />
                  </Button>

                 
                </div>
            </div>
          </div>
          <div className="page-content">
            <div className="container">
              <Row>
                <Col md={24} lg={16} xl={16} span={24}>
                  <div className="page-content__left">
                    <div>
                      <h3 className="box__title">Şirket Bilgileri</h3>
                      <Row gutter={20}>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="kurumAdi" 
                            messageVariables={{ label: 'name' }}
                            getValueFromEvent={(e) => {
                             return  turkishToUpper(e.target.value || '')
                            }}
                          >
                            <Input disabled={!newFirm} 
                              type="text" style={{ textTransform: 'uppercase'}}
                              label="Kurum Adı"
                              name="kurumAdi"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={20}>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="vergiDairesi" 
                            messageVariables={{ label: 'name' }}
                            getValueFromEvent={(e) => {
                              return  turkishToUpper(e.target.value || '')
                            }}
                          >
                            <Input disabled={!newFirm}
                              type="text" style={{ textTransform: 'uppercase'}}
                              label="Vergi Dairesi"
                              name="vergiDairesi"
                            />
                          </Form.Item>
                        </Col>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="vergiNo"
                            messageVariables={{ label: 'name' }}
                          >
                            <Input disabled={!newFirm}
                              type="text"
                              label="Vergi Numarası"
                              name="vergiNo"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <h3 className="box__title">Gerekli Belgeler</h3>
                      <Row gutter={20}>
                        
                        {newFirm &&
                        <Col sm={24} md={24} lg={24} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: !newFirm }]}
                            id="commercialFile" 
                            name="commercialFile" hidden={!newFirm}
                            messageVariables={{ label: 'file-document' }}
                          >
                            <SelectFile allowExtensions={["doc","docx","pdf","zip"]}
                              typeV2 
                              onChange={(e)=>  {
                                if (e.files) 
                                {setCommercialFileList(e.files[0])
                                }
                              }}
                              typeName="file-2"
                              type="file"
                              id="commercialFile"
                              title={
                                <>
                                  <span>Ticari faliyet belgesi yükle</span>
                                </>
                              }
                              icon={<UploadIcon />}
                            />
                          </Form.Item>
                        </Col>}  {newFirm &&
                        <Col sm={24} md={24} lg={24} xl={12} span={24}>
                          <Form.Item
                             rules={[{ required: newFirm }]}
                            name="taxFile" hidden={!newFirm}
                            id="taxFile"
                            messageVariables={{ label: 'file-document' }}
                          >
                            <SelectFile allowExtensions={["doc","docx","pdf","zip"]}
                              typeV2   onChange={(e)=> 
                                {
                                  if (e.files) 
                                  {setTaxFileList(e.files[0])
                                  }
                                }}
                              typeName="file-3"
                              id="taxFile"
                              type="file"
                              title={
                                <>
                                  <span>Vergi levhası yükle</span>
                                </>
                              }
                              icon={<UploadIcon />}
                            />
                          </Form.Item>
                        </Col>
                        }<Col sm={24} md={24} lg={24} xl={24} span={24}>
                        <Form.Item
                          name="additionalFile" 
                          messageVariables={{ label: 'file-document' }}
                         
                        >
                          <SelectFile allowExtensions={["doc","docx","pdf","zip"]}
                            compClass="mobile-vertical"
                            typeV2
                            id="additionalFile"
                            type="file" onChange={(e)=>  {
                              if (e.files) 
                              {setAdditionalFileList(e.files[0])
                              }
                            }}
                            title={
                              <>
                                <span>Ek döküman yükle</span>
                                <p>
                                  Kullanmak istediğiniz ünvanın işletmenize
                                  ait olduğunu kanıtlamak amacıyla ihtiyaç
                                  duyulabileceğini düşündüğünüz dökümanları
                                  eklemenizi öneririz.
                                </p>
                              </>
                            }
                            icon={<UploadIcon />}
                          />
                        </Form.Item>
                      </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col
                  md={24}
                  lg={{ span: 6, offset: 2 }}
                  xl={{ span: 6, offset: 2 }}
                  span={24}
                >
                  <div>
                    <MessagesSummary
                      compClass="mobile-type-2"
                      typeV2
                      identityInfo={
                        <>
                          {firmData.user && 
                           <>{firmData.user.name} {firmData.user.surname}  <br /> {firmData.user.tckNo} <br />  {firmData.user.cuzdanSeriNo} <br />
                          </>
                        }
                        </>
                      }
                      companyInfo={
                        <>
                          {firmData.userFirm && 
                           <>{firmData.userFirm.kurumAdi}  <br /> {firmData.userFirm.vergiDairesi} <br />  {firmData.userFirm.vergiNo} <br />
                          </>
                        }
                        </>
                      }
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Form></React.Fragment>

          <Modal
        title="Önemli Bilgilendirme"
        visible={modalInfo}
        className="info-modal"
        onCancel={() => setModalInfo(false)}
        footer={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyItems: 'center',
            }}
          >
            <Button
              style={{ marginLeft: '0' }}
              type="primary"
              onClick={() => setModalInfo(false)}
            >
              Anladım
            </Button>
          </div>
        }
      >
        <div style={{ textAlign: 'justify', paddingRight: '2px' }}>
          <p>
            Bilgi Teknolojileri ve İletişim Kurulu'nun <strong>16.12.2025</strong> tarih ve{' '}
            <strong>2025/DK-YED/399</strong> sayılı kararı kapsamında, uygulamadan kişiye (A2P)
            SMS ve MMS gibi mesaj hizmetlerini sunan işletmecilerin bu hizmetler
            özelinde alacağı abonelik başvuruları ve bu başvuruya ilişkin bilgi
            ve belgeleri <strong>Kayıtlı Elektronik Posta (KEP)</strong> vasıtasıyla alması{' '}
            <strong>1 Nisan 2026</strong> itibarıyla zorunlu tutulmuştur.
          </p>
          <p>
            Mesaj başlığı başvurunuza ilişkin Mesaj Üssü platformuna yüklediğiniz
            bilgi ve belgeleri <strong>48 saat</strong> içinde aşağıda belirtilen{' '}
            <strong>Turkcell Mesaj Üssü KEP adresine</strong>, <strong>tarafınıza ait KEP hesabı
            vasıtasıyla göndermeniz gerekmektedir.</strong> KEP hesabınız vasıtasıyla
            iletilmeyen başvurular değerlendirmeye alınmayacak ve{' '}
            <strong>48 saat</strong> sonra iptal edilecektir.
          </p>
          <p style={{ marginBottom: '0' }}>Turkcell Mesaj Üssü KEP adresi: <strong>turkcell.mesajussu@hs03.kep.tr</strong></p>
        </div>
      </Modal>
    </>
  );
};

export default CompanyTitle;
